export class ServiceInfo {
    public static buildAutopartage() : ServiceInfo{
        return new ServiceInfo(0,
            "autopartage",
            "autopartage",
            true,
            "theme-autopartage",
            "/autopartage",
            "autopartage",
            "autopartage",
             "Je réserve un véhicule",
             "Text  de présentation");
    }

    public static buildRecharge() : ServiceInfo{
        return new ServiceInfo(1,"recharge","recharge",false,
        "theme-recharge",
        "/recharge",
        "recharge",
        "recharge",
        "Je recharge mon véhicule",
        "Text  de présentation");
    }

    public static buildPartageTrajet() : ServiceInfo {
        return new ServiceInfo(2,
            "patage-trajet",
            "partage-trajet",
            false,
            "theme-solidrive",
            "/partage-de-trajet",
            "partage-trajet",
            "partage-trajet",
            "Je covoiture",
            "Text  de présentation")
    }

    public static buildVelo() : ServiceInfo {
        return new ServiceInfo(3,
            "velo",
            "velo",
            false,
            "theme-velo",
            "/velo",
            "velo",
            "velo",
            "Je réserve un vélo",
            "Text  de présentation")
    }

    public static buildTrajet() : ServiceInfo {
        return new ServiceInfo(4,
            "trajet",
            "trajet",
            false,
            "theme-trajet",
            "/velo",
            "trajet",
            "trajet",
            "Trajet",
            "Text  de présentation")
    }

    constructor(public id:number,
        public name:string,
        public serviceMobilePicto:string,
        public isSelected:boolean,
        public scssPrefix:string,
        public routingData:string,
        public ImageMenuSrc : string,
        public ImageMenuSrcSelected : string,
        public menuTitle : string,
        public menuDetail : string
            ) {
                
            }

}